"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _excluded = ["elementInError"];

var _default = function _default() {
  var validations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var submitAttempted = arguments.length > 1 ? arguments[1] : undefined;
  var _validations$elementI = validations.elementInError,
      elementInError = _validations$elementI === void 0 ? false : _validations$elementI,
      validators = (0, _objectWithoutProperties2["default"])(validations, _excluded);

  if (elementInError && submitAttempted) {
    var errorId = '';
    Object.values(validators).some(function (val) {
      errorId = val.error ? val.errorMessageId : '';
      return val.error;
    });
    return errorId;
  }

  return '';
};

exports["default"] = _default;